import { defineStore } from 'pinia'
import SettingsApi from '~/api/SettingsApi'

interface SettingsState {
  medicalTerms: string[]
  chatEnabled: boolean
  featureFlagsLoaded: boolean
}

export const useSettingsStore = defineStore('settings', {
  state: (): SettingsState => ({
    medicalTerms: [],
    chatEnabled: true,
    featureFlagsLoaded: false,
  }),

  actions: {
    async fetchMedicalTerms(): Promise<void> {
      await SettingsApi.medicalTerms().then((response: string[]) => {
        this.medicalTerms = response
      })
    },

    async fetchFeatureFlags(): Promise<void> {
      if (this.featureFlagsLoaded) return
      try {
        const response = await SettingsApi.featureFlags()
        this.chatEnabled = response.chat_enabled
      } finally {
        this.featureFlagsLoaded = true
      }
    },
  },
})
